import { Component, Mixins, Prop } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import { Dictionary } from '@/types';
import { Item, Variants, CostText } from './types';
import Image from './image';
import PrivateLink from './components/Link.vue';

@Component({
  components: { PrivateLink },
})
export default class ComponentPartCatalogListCardCommon
  extends Mixins(Image)
  implements Item
{
  @Prop({ type: [String, Number], required: true })
  id: string;

  @Prop({ type: String, default: '' })
  code: string;

  @Prop({ type: String, default: '' })
  cop_multi_name: string;

  @Prop({ type: String, default: '' })
  cop_multi: string;

  @Prop({ type: Boolean, default: true })
  constrainNameHeight: boolean;

  @Prop({ type: String, required: true })
  title: string;

  @Prop({ type: String, required: true })
  img: string;

  @Prop({ type: String, default: '' })
  note: string;

  @Prop({ type: [Array, String], default: () => [] })
  text: Array<string> | string;

  @Prop({ type: String })
  age: string;

  @Prop({ type: Number })
  price: number;

  @Prop({ type: Boolean, default: false })
  rate: boolean;

  @Prop({ type: Boolean, default: false })
  is_locked: boolean;

  @Prop({ type: Boolean, default: undefined })
  available_order_next_year: boolean | undefined;

  @Prop({ type: Boolean, default: undefined })
  available_order_current_year: boolean | undefined;

  @Prop({ type: [Number, String], default: '' })
  size: number | string;

  @Prop({ type: Number, default: 0 })
  rating: number;

  @Prop(String)
  duration: string;

  @Prop({ type: [String, Number], default: null })
  max_person: string | number;

  @Prop({ type: Array, default: () => [] })
  badge: Array<any>;

  @Prop(String)
  message: string;

  @Prop(String)
  status: string;

  @Prop({ type: [Boolean, String, Object], default: false })
  link: false | RawLocation;

  @Prop({ type: [Boolean, String], default: false })
  target: false | string;

  @Prop({
    default: false,
    type: [Boolean, String],
    validator: (v) =>
      v === false ||
      Object.values(Variants).some((e: Variants): boolean => e === v),
  })
  variant: false | Variants;

  @Prop({ type: Boolean, default: false })
  showClose?: boolean;

  @Prop({ type: String, default: '' })
  academicYear: string;

  @Prop({ type: Boolean, default: false })
  deducted?: boolean;

  @Prop({ type: String, default: '' })
  cost: string | number;

  @Prop({ type: String, default: '0' })
  form_education_id: string;

  @Prop({ type: String, default: '' })
  labor_program: string;

  @Prop({ type: String, default: '' })
  length: string;

  @Prop({ type: Boolean, default: false })
  is_free: boolean;

  @Prop({ type: Boolean, default: true })
  is_open: boolean;

  @Prop({ type: Object, default: true })
  schedule_dates: any;

  get to(): RawLocation {
    const { id, code, link } = this;
    return link !== false
      ? link
      : {
          name: 'event-card',
          params: {
            id: String(id),
            code,
          },
        };
  }

  get showBadge() {
    const { badge } = this;
    return badge && badge.length > 0;
  }

  get imgStyle() {
    const { img, imageBgColor } = this;
    const result: Dictionary<string> = {};
    if (img) result.backgroundImage = `url(${img})`;
    if (imageBgColor) result.backgroundColor = imageBgColor;
    return result;
  }

  get isTextArray(): boolean {
    return Array.isArray(this.text) && this.text.length > 0;
  }

  get isTextString(): boolean {
    return typeof this.text === 'string' && this.text.length > 0;
  }

  get isLockedText(): boolean {
    return !this.is_open;
  }

  get formEducation() {
    const result = this.$store.state.educationForm.find(
      (item: any) => item.id === parseInt(this.form_education_id)
    );
    return result ? result.name : '';
  }

  get programCost() {
    const { cost, is_free } = this;
    return is_free ? CostText.FREE : cost ? cost : '';
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/item/common.ts